import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import APIURL from "../../helper/environment";

const Signup = (props) => {
  // UserState Variables On Top
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  //BrowserRouter Hook
  const navigate = useNavigate();
  //Function here

  async function handleSubmit(e) {
    e.preventDefault();
    let url = `${APIURL}/owner/signup`;
    let bodyObject = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      password: password,
    };

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(bodyObject),
    };
    try {
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      console.log(data);
      if (
        data.message === "Account has been created" ||
        data.message === "New Administrative Account has been Created"
      ) {
        //! Will change dependant on back end
        props.updateToken(data.updateToken);

        navigate("/Lots"); //! Must add
      }
    } catch (error) {
      console.error(error.message);
    }
  }

  return (
    <>
      <div className="App">
        <div className="auth-form-container1" display="center">
          <h2 className="text-center">Signup</h2>
          <Form className="signup-form" onSubmit={handleSubmit}>
            {/* Star of First Name */}
            <FormGroup>
              <Label> First Name:</Label>
              <Input
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </FormGroup>
            {/* End of First Name */}
            {/* Star of LastName */}
            <FormGroup>
              <Label> Last Name:</Label>
              <Input
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </FormGroup>
            {/* End of LastName */}
            {/* Star of Email */}
            <FormGroup>
              <Label>Email:</Label>
              <Input value={email} onChange={(e) => setEmail(e.target.value)} />
            </FormGroup>
            {/* End of Email */}
            {/* Star of Password */}
            <FormGroup>
              <Label>Password:</Label>
              <Input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {/* End of Password */}
            </FormGroup>
            <div className="text-center d-grid gap-2 mb-4">
              <Button type="submit" color="warning">
                Signup
              </Button>
            </div>

            <div className="d-flex flexrow align-items-center justify-content-center pb-4 mb-4">
              <p className="mb-0 align-item-center">Already have an account?</p>
              <Button
                onClick={() => props.setCurrentForm("login")}
                // outline
                className="mx-2"
                color="dark"
              >
                Login
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default Signup;
